import { colors, rgbToHex, Tooltip } from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import IconButton from '@material-ui/core/IconButton/IconButton';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography/Typography';
import { Block } from '@material-ui/icons';
import InfoIcon from '@material-ui/icons/Info';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { ToggleButton } from '@material-ui/lab';
import clsx from 'clsx';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { recordActions } from '../../ducks/records';
import { selectVisibleValidationErrors } from '../../ducks/records/reducers';
import SupervisionHelpDialog from './SupervisionHelpDialog';
import SupervisionScale from './SupervisionScale';
import { t } from '../../commons/Translate.js'

const styles = theme => ({
  wrapper: {
    border: '2px solid',
    borderColor: colors.grey[300],
    background: '#e3f2fd63',
    borderRadius: '.5rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  hasErrors: {
    border: '2px solid',
    borderColor: colors.red[900],
  },
  supervisionTitle: {
    fontSize: '1.3rem'
  }
})

const StyledToggleButton = withStyles((theme) => ({
  root: {
    padding: '3px',
    paddingLeft: '7px'
  },
  label: {
    textTransform: 'none'
  },
  selected: {
    color: theme.palette.secondary.main + ' !important',
    backgroundColor: rgbToHex(theme.palette.secondary.light) + '3d !important',
  }
}))(ToggleButton)

const EpaSupervisionBlock = props => {

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleSetSupervisionToNone = () => changeSupervision(supervisionIsNone ? undefined : null)
  const { classes, changeSupervision, form, recordValidationErrors } = props
  const supervisionIsNone = form.supervision === null
  const supervisionIsNotSet = form.supervision === undefined
  const storedValue = form.supervision || null
  const hasError = recordValidationErrors.find(error => error.property === 'supervision')
  const tooltipTitle = supervisionIsNone ? t('Skala für Supervisionlevel aktivieren') : <Typography fontSize={30}>{t('Bitte im Freitext begründen!')}</Typography>
  return (
    <>
      <Grid container direction={'column'} className={clsx(classes.wrapper, hasError && classes.hasErrors)}>
        <Grid item>
          <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography className={classes.supervisionTitle} gutterBottom>
              {t('Supervisionslevel')}
            </Typography>
            <div>
              <Tooltip title={tooltipTitle}>
                <StyledToggleButton value="check" selected={supervisionIsNone} onChange={handleSetSupervisionToNone} size='small'>
                  {t('Nicht beurteilbar')}&nbsp;
                  <Block fontSize='small'/>
                </StyledToggleButton>
              </Tooltip>
              <IconButton onClick={handleOpen} aria-label="info">
                <Tooltip title={t("Erklärung der Skala")}>
                  <InfoIcon/>
                </Tooltip>
              </IconButton>
              <IconButton color="primary" disabled={supervisionIsNotSet} onClick={() => changeSupervision(undefined)} aria-label="reset">
                <Tooltip title={t("Skala zurücksetzen")}>
                  <SettingsBackupRestoreIcon/>
                </Tooltip>
              </IconButton>
            </div>
          </Grid>
        </Grid>
        <Grid item>
          <SupervisionScale value={storedValue} onChange={(event, value) => changeSupervision(value)}/>
        </Grid>
      </Grid>
      <SupervisionHelpDialog open={open} handleClose={handleClose}/>
    </>
  )
}

const mapStateToProps = ({ record }) => ({
  form: selectCurrentForm(record),
  recordValidationErrors: selectVisibleValidationErrors(record),
})

const selectCurrentForm = recordState => {
  return {
    ...recordState.selectedEpa,
    ...recordState.record.epas.find(epa => epa.id === recordState.selectedEpa.id)
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeSupervision: recordActions.setSupervisionLevel
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EpaSupervisionBlock))
